import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Loading from "../components/utils/loader";
import loadable from "@loadable/component";
import CoachingCoursesForm from "../components/cms/coaching/coachingCourses/coachingCoursesForm";
import PermissionDenied from "../components/cms/common/permissionDenied";
import DeleteConfirmation from "../components/cms/common/deleteConfirmation";
import DeleteConfirmationRegister from "../components/cms/registration/deleteConfirmationRegister";
import DeleteAccountConfirmation from "../components/cms/registration/userAccountDeletion/accountDeleteConfirmation"
import PublishConfirmation from "../components/cms/common/publishConfirmation";
import UnPublish from "../components/cms/common/unPublish";
import ToppersDetails from "../components/cms/coaching/toppersDetails";
import Country from "../components/cms/country";
import Domain from "../components/cms/domain";
import ContactUserPush from "../components/cms/contactUserPush/index";
import HiringOverview from "../components/cms/hiring";
import ManageStaffRegister from "../components/cms/permission/manageStaffRegister";
import StaticPagesOverview from "../components/cms/staticPages"
import ToolsHome from "../components/cms/tools";
import FeedbackTool from "../components/cms/tools/CPFeedbackTool";
import AuthorHome from "../components/cms/authorProfile"
import ManageAuthor from "../components/cms/authorProfile/manageAuthor"
import DeleteAuthor from "../components/cms/authorProfile/deleteAuthor"
import ManageRP from "../components/cms/manageRP";
import ManagePredictor from "../components/cms/tools/predictorTool";
import PredictorAddEdit from "../components/cms/tools/predictorTool/predictorAddEdit"
import WebStoriesFilter from "../components/cms/content/webStories/filterBlock";
import EditWebStories from "../components/cms/content/webStories/addEditWebStories";
import {PollsHome} from "../components/cms/pollManagement";
import DomainMapping from "../components/cms/DomainMapping";


const CMSDashboard = loadable(() => import("../components/cms/dashboard"), {
  fallback: () => <Loading />,
});
const CMSLogin = loadable(() => import("../components/cms/cmsLogin/login"), {
  fallback: () => <Loading />,
});
const CMSPermission = loadable(() => import("../components/cms/permission"), {
  fallback: () => <Loading />,
});
const Webinar = loadable(() => import("../components/cms/webinar"), {
  fallback: () => <Loading />,
});
const ManageWebinar = loadable(() => import("../components/cms/webinar/manageWebinar"), {
  fallback: () => <Loading />,
});
const Newsletter = loadable(() => import("../components/cms/newsletter"), {
  fallback: () => <Loading />,
});
const AddEdit = loadable(() => import("../components/cms/newsletter/addEdit"), {
  fallback: () => <Loading />,
});
const ViewNewsletter = loadable(
  () => import("../components/cms/newsletter/viewNewsletter"),
  {
    fallback: () => <Loading />,
  }
);
const ProductHome = loadable(() => import("../components/cms/products"), {
  fallback: () => <Loading />,
});
const ManageMapping = loadable(
  () => import("../components/cms/articleWebinarMapping/manageMapping"),
  {
    fallback: () => <Loading />,
  }
);
const Coaching = loadable(() => import("../components/cms/coaching"), {
  fallback: () => <Loading />,
});
const ManageRanking = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking"), {
  fallback: () => <Loading />,
});
const ManageCollegeRanking = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking/addCollege"), {
  fallback: () => <Loading />,
});
const EditCollege = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking/editCollege"), {
  fallback: () => <Loading />,
});
const CollegeList = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking/courseRanking/collegeList"), {
  fallback: () => <Loading />,
});
const CourseHome = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking/courseRanking"), {
  fallback: () => <Loading />,
});
const EditCourseRank = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking/courseRanking/editCourseRank"), {
  fallback: () => <Loading />,
});
const AddCourseRank = loadable(() => import("../components/cms/manageRanking/studyabroadCollegeRanking/courseRanking/addCourseRank"), {
  fallback: () => <Loading />,
});
const RankingBase = loadable(() => import("../components/cms/manageRanking/base"), {
  fallback: () => <Loading />,
});

const RegistrationHome = loadable(() => import("../components/cms/registration"), {
  fallback: () => <Loading />,
})
const DegreeGroupingHome = loadable(() => import("../components/cms/degreeGrouping"), {
  fallback: () => <Loading />,
})
const ArticleBase = loadable(() => import("../components/cms/content"), {
  fallback: () => <Loading />,
});
const ManageFilterForApp = loadable(() => import("../components/cms/content/articleApp/manageFilterForApp"), {
  fallback: () => <Loading />,
});
const EditArticleForApp = loadable(() => import("../components/cms/content/articleApp/editArticle"), {
  fallback: () => <Loading />,
});
const VideoHome = loadable(() => import("../components/cms/video"), {
  fallback: () => <Loading />,
})
const ManageVideo = loadable(() => import("../components/cms/video/manageVideo"), {
  fallback: () => <Loading />,
})
const ManageFaqs = loadable(() => import("../components/cms/faqPanel"), { 
  fallback: () => <Loading /> 
});


// const CMSExam = loadable(() => import('@/components/cms/exam') fallback: () => <Loading /> });
// const AddExam = loadable(() => import('@/components/cms/exam/addExam'),{ssr: false, fallback: () => <Loading />});
// const EditExam = loadable(() => import('@/components/cms/exam/editExam'),{ssr: false, fallback: () => <Loading />});

// const CollegeHome = loadable(() => import('@/components/cms/colleges'),{ssr: false, fallback: () => <Loading />});
// const OverviewHome = loadable(() => import('@/components/cms/colleges/addThirdEntity'),{ssr: false, fallback: () => <Loading />});
// const EditProgramme = loadable(() => import('@/components/cms/colleges/manage-programme'),{ssr: false, fallback: () => <Loading />});
// const AddInstitute = loadable(() => import('@/components/cms/colleges/manageInstitute'),{ssr: false, fallback: () => <Loading />});
const CMSRoutes = (props) => {
  const userPermission = props.permission?.data;
  const ROUTES = [
    { path: "/cms", exact: true, element: <CMSDashboard />, application: "" },
    {
      path: "/cms/login",
      exact: true,
      element: <CMSLogin />,
      application: "",
    },

    // <--------Permission Routes----->

    {
      path: "/cms/permission",
      exact: true,
      element: <CMSPermission />,
      application: "auth",
    },
    {
      path: "/cms/permission/:param",
      exact: true,
      element: <CMSPermission />,
      application: "auth",
    },
    {
      path: "/cms/permission/:param/:id",
      exact: true,
      element: <CMSPermission />,
      application: "auth",
    },
    {
      path: "cms/permission/:param",
      exact: true,
      application: "",
      element: <ManageStaffRegister />
    },
    {
      path: "cms/permission/:param/:id",
      exact: true,
      application: "",
      element: <ManageStaffRegister />
    },
    {
      path: "/cms/author",
      exact: true,
      element: <AuthorHome />,
      application: "",
    },
    {
      path: "/cms/author/manage-author-profile",
      exact: true,
      value: "",
      element: <ManageAuthor />,
      application: "author_admin",
      action: "Can Create Author Profile",
    },
    {
      path: "/cms/author/manage-author-profile/:id",
      exact: true,
      value: "",
      element: <ManageAuthor />,
      application: "author_admin",
      action: "Can Edit Author Profile",
    },
    {
      path: "/cms/author/manage-author-profile/:id/delete",
      exact: true,
      application: "author_admin",
      element: <DeleteAuthor />,
      action: "Can Delete Author",
    },
    // <--------Permission Routes----->

    // <--------Webinar Routes----->
    {
      path: "/cms/webinar",
      exact: true,
      element: <Webinar />,
      application: "webinar",
    },
    {
      path: "/cms/webinar/:param",
      exact: true,
      element: <ManageWebinar />,
      application: "webinar",
    },
    {
      path: "/cms/webinar/:param/:id",
      exact: true,
      element: <ManageWebinar />,
      application: "webinar",
    },
    // <--------Webinar Routes----->

    // <--------Newsletter Routes----->
    {
      path: "/cms/newsletter",
      exact: true,
      element: <Newsletter />,
      application: "",
    },
    {
      path: "/cms/newsletter/add-edit/",
      exact: true,
      element: <AddEdit />,
      application: "",
    },
    {
      path: "/cms/newsletter/add-edit/:id",
      exact: true,
      element: <AddEdit />,
      application: "",
    },
    {
      path: "/cms/newsletter/viewnewsletter",
      exact: true,
      element: <ViewNewsletter />,
      application: "",
    },
    // <--------Newsletter Routes----->

    // <--------Product Routes----->
    {
      path: "/cms/products",
      exact: true,
      element: <ProductHome />,
      application: "",
    },
    {
      path: "/cms/products/:param/",
      exact: true,
      element: <ProductHome />,
      application: "",
    },
    {
      path: "/cms/products/:param/:id",
      exact: true,
      element: <ProductHome />,
      application: "",
    },
    // <--------Product Routes----->

    // <--------Article Webinar Mapping Routes----->
    {
      path: "/cms/article-webinar-mapping",
      exact: true,
      element: <ManageMapping />,
      application: "spgentitymapping",
    },
    // <--------Article Webinar Mapping Routes----->

    // <--------Exam Routes----->
    // {path:'/cms/exam' ,exact:true, element:C<MSExam/>,application:''},
    // {path:'/cms/exam/add' ,exact:true, element:A<ddExam/>,application:''},
    // {path:'/cms/exam/edit' ,exact:true, element:E<ditExam/>,application:''},
    // {path:'/cms/exam/edit/:param' ,exact:true, element:E<ditExam/>,application:''},
    // <--------Exam Routes----->

    // <--------College Routes----->
    // {path:'/cms/colleges' ,exact:true, element:C<ollegeHome/>,application:''},
    // {path:'/cms/colleges/:param/' ,exact:true, element:C<ollegeHome/>,application:''},
    // {path:'/cms/colleges/:param/add-edit' ,exact:true, element:C<ollegeHome/>,application:''},
    // {path:'/cms/colleges/:param/add-edit/:id' ,exact:true, element:C<ollegeHome/>,application:''},
    // {path:'/cms/colleges/add-third-entity/' ,exact:true, element:O<verviewHome/>,application:''},
    // {path:'/cms/colleges/add-third-entity/:param/' ,exact:true, element:O<verviewHome/>,application:''},
    // {path:'/cms/colleges/manage-programme/:param/' ,exact:true, element:E<ditProgramme/>,application:''},
    // {path:'/cms/colleges/manage-institute/:param/' ,exact:true, element:A<ddInstitute/>,application:''}
    // <--------College Routes----->

    // <--------Coaching Routes----->
    {
      path: "/cms/coaching",
      exact: true,
      element: <Coaching />,
      application: "cnextcoachingmaster",
    },
    {
      path: "/cms/coaching/:param",
      exact: true,
      element: <Coaching />,
      application: "cnextcoachingmaster",
      action: "Can Add Coaching Data",
    },
    {
      path: "/cms/coaching/:id/:param",
      exact: true,
      element: <Coaching />,
      application: "cnextcoachingmaster",
      action: "Can Edit Coaching Data",
    },
    {
      path: "/cms/coaching/:id/:param/delete",
      exact: true,
      element: <DeleteConfirmation />,
      application: "cnextcoachingmaster",
      action: "Can Delete Coaching Data",
    },
    {
      path: "/cms/coaching/:id/coaching-courses/course",
      exact: true,
      application: "cnextcoachingmaster",
      element: <CoachingCoursesForm />,
      action: "Can Add Coaching Courses Data",
    },
    {
      path: "/cms/coaching/:id/coaching-courses/:courseId/course",
      exact: true,
      application: "cnextcoachingmaster",
      element: <CoachingCoursesForm />,
      action: "Can Edit Coaching Courses Data",
    },
    {
      path: "/cms/coaching/:id/coaching-courses/:courseId/course/delete",
      exact: true,
      application: "cnextcoachingmaster",
      element: <DeleteConfirmation />,
      action: "Can Delete Coaching Courses Data",
    },
    {
      path: "/cms/coaching/:id/:param/publish",
      exact: true,
      application: "cnextcoachingmaster",
      element: <PublishConfirmation />,
      action: "Can Publish Coaching Data",
    },
    {
      path: "/cms/coaching/:id/:param/unpublish",
      exact: true,
      application: "cnextcoachingmaster",
      element: <UnPublish />,
      action: "Can Unpublish Coaching Data",
    },
    {
      path: "/cms/coaching/:id/coaching-courses/:courseId/course/publish",
      exact: true,
      application: "cnextcoachingmaster",
      element: <PublishConfirmation />,
      action: "Can Publish Coaching Courses Data",
    },
    {
      path: "/cms/coaching/:id/coaching-courses/:courseId/course/unpublish",
      exact: true,
      application: "cnextcoachingmaster",
      element: <UnPublish />,
      action: "Can Unpublish Coaching Courses Data",
    },
    // <--------Coaching Routes----->

    // <--------Country Routes----->
    {
      path: "/cms/country",
      exact: true,
      application: "countrydata",
      element: <Country />,
    },
    {
      path: "/cms/country/:id/:param",
      exact: true,
      element: <Country />,
      application: "countrydata",
      action: "Can Edit Country Data",
    },
    // <--------Country Routes----->
    // <--------DegreeGrouping Routes-------->
    {
      path: "/cms/degree-grouping",
      exact: true,
      application: "",
      element: <DegreeGroupingHome />
    },
    {
      path: "/cms/degree-grouping/:param/",
      exact: true,
      element: <DegreeGroupingHome />,
      application: "",
    },
    {
      path: "/cms/degree-grouping/:param/:id",
      exact: true,
      element: <DegreeGroupingHome />,
      application: "",
    },

    // <--------DegreeGrouping Routes Ended-------->


    // <--------Registration Routes-------->
    {
      path: "/cms/register",
      exact: true,
      application: "registration",
      action:"Manage Signup Messaging",
      element: <RegistrationHome />
    },
    {
      path: "/cms/register/:param/",
      exact: true,
      element: <RegistrationHome />,
      application: "registration",
      action:"Manage Signup Messaging",
    },
    {
      path: "/cms/register/:param/:id",
      exact: true,
      element: <RegistrationHome />,
      application: "registration",
      action:"Manage Signup Messaging",
    },
    {
      path: "/cms/register/:id/:param/delete",
      exact: true,
      element: <DeleteConfirmationRegister />,
      application: "registration",
      action:"Manage Signup Messaging",
    },
    // <--------Registration Routes Ended-------->

    // <--------User Account Deletion Routes-------->
    {
      path: "/cms/user-account-deletion/:id/delete",
      exact: true,
      element: <DeleteAccountConfirmation />,
    },
    // <--------User Account Deletion Ended-------->

    // <--------Domain Routes----->
    {
      path: "/cms/domain",
      exact: true,
      application: "user",
      element: <Domain />,
    },
    // <--------Domain Routes----->

    // <--------Contact User Push----->
    {
      path: "/cms/user-contact-push",
      exact: true,
      application: "logentry",
      element: <ContactUserPush />,
    },

    // <--------Contact User Push----->

    // <--------Hiring Routes----->
    {
      path: "/cms/hiring",
      exact: true,
      element: <HiringOverview />,
      application: "",
    },
    {
      path: "/cms/hiring/:param/",
      exact: true,
      element: <HiringOverview />,
      application: "",
    },
    {
      path: "/cms/hiring/:param/:id",
      exact: true,
      element: <HiringOverview />,
      application: "",
    },
    // <--------Hiring Routes----->
    // <--------Video Routes----->
    {
      path: "/cms/video",
      exact: true,
      application: "",
      element: <VideoHome />,
    },
    {
      path: "/cms/video/:param",
      exact: true,
      application: "",
      element: <ManageVideo />,
    },
    {
      path: "/cms/video/:param/:id",
      exact: true,
      application: "",
      element: <ManageVideo />,
    },

    // <--------Video Routes----->
    // <--------Static Page----->
    {
      path: "/cms/static-pages",
      exact: true,
      application: "base",
      element: <StaticPagesOverview />,
    },
    {
      path: "/cms/static-pages/:param",
      exact: true,
      application: "base",
      element: <StaticPagesOverview />,
    },

    // <--------Static Page----->
    // <--------Studyabroad College Ranking Routes----->
    {
      path: "/cms/manage-ranking",
      exact: true,
      application: "",
      element: <RankingBase> <ManageRanking /> </RankingBase>,
    },
    {
      path: "/cms/manage-ranking/add-colleges",
      exact: true,
      application: "",
      element: <RankingBase> <ManageCollegeRanking /> </RankingBase>,
    },
    // here type is college, entity_id is college's entity_id, param is authority
    {
      path: "/cms/manage-ranking/:type/:entity_id/:param/:ranking_upload_id",
      exact: true,
      application: "",
      element: <RankingBase> <EditCollege /> </RankingBase>,
    },
    // <--------Studyabroad Course Ranking Routes-------->
    {
      path: "/cms/manage-ranking/colleges",
      exact: true,
      application: "",
      element: <RankingBase> <CollegeList /> </RankingBase>,
    },
    {
      path: "/cms/manage-ranking/:type/:id/:param",
      exact: true,
      application: "",
      element: <RankingBase> <CourseHome /> </RankingBase>,
    },
    {
      path: "/cms/manage-ranking/colleges/:id/add-course",
      exact: true,
      application: "",
      element: <RankingBase> <AddCourseRank /></RankingBase>,
    },
    {
      path: "/cms/manage-ranking/colleges/:college_id/courses/:course_id/ranking_detail/:ranking_detail_id",
      exact: true,
      application: "",
      element: <RankingBase> <EditCourseRank /> </RankingBase>,
    },

    // -----Manage Ranking Routes----->
    //<---------TOOL Panel------------->
    {
      path: "/cms/tools",
      exact: true,
      application: "college_predictor",
      action: "Can Map Tools Feedbacks",
      element: <ToolsHome />,
    },
    {
      path: "/cms/tools/:param",
      exact: true,
      application: "",
      action: "",
      element: <ToolsHome />,
    },

    // manage predictor
    {
      path: "/cms/tools/manage-predictor/:type",
      exact: true,
      application: "manage_predictor_tools_cnext_manage_tools",
      action: "Manage Predictor Tools",
      element: <PredictorAddEdit />,
    },
    {
      path: "/cms/tools/manage-predictor/:type/:id",
      exact: true,
      application: "manage_predictor_tools_cnext_manage_tools",
      action: "Manage Predictor Tools",
      element: <PredictorAddEdit />,
    },
  
    //<---------FEEDBACK TOOL------------->

    // Article For APP
     {
      path: "/cms/content/",
      exact: true,
      application: "",
      element: <ArticleBase> <ManageFilterForApp /> </ArticleBase>,
    },
    {
      path: "/cms/content/article-app/:param/:id",
      exact: true,
      application: "",
      element: <ArticleBase> <EditArticleForApp /> </ArticleBase>,
    },
    // routes added for Web Stories under Content menu
    {
      path: "/cms/content/web-stories",
      exact: true,
      application: "webstory",
      action:'View Webstory Mapping Listing',
      element: <ArticleBase><WebStoriesFilter /></ArticleBase>,
    },
    {
      path: "/cms/content/web-stories/add-edit",
      exact: true,
      application: "webstory",
      action:'Add Webstory Mapping',
      element: <ArticleBase> <EditWebStories /> </ArticleBase>,
    },
    {
      path: "/cms/content/web-stories/add-edit/:id",
      exact: true,
      application: "webstory",
      action:'Edit Webstory Mapping',
      element: <ArticleBase> <EditWebStories /> </ArticleBase>,
    },

    // ai faqs generation routes
    {
      path: "/cms/faqs",
      exact: true,
      element: <ManageFaqs />,
      application: "",
    },
    {
      path: "/cms/faqs/:param/",
      exact: true,
      element: <ManageFaqs />,
      application: "",
    },
    {
      path: "/cms/faqs/:param/:id",
      exact: true,
      element: <ManageFaqs />,
      application: "",
    },
    // <--------Poll Management Routes-------->
    {
      path: "/cms/polls",
      exact: true,
      element: <PollsHome />
    },
    {
      path: "/cms/polls/:params",
      exact: true,
      element: <PollsHome />
    },
    {
      path: "/cms/polls/:params/:id",
      exact: true,
      element: <PollsHome />
    },

    // ------------manage rp -------------
    {
      path:"/cms/manage-rp",
      exact:true,
      element:<ManageRP/>
    },
    {
      path:"/cms/manage-rp/:param",
      exact:true,
      element:<ManageRP/>
    },
    {
      path:"/cms/manage-rp/:param/add-edit/:id",
      exact:true,
      element:<ManageRP/>
    },
    {
      path:"/cms/manage-rp/:param/add-edit",
      exact:true,
      element:<ManageRP/>
    },


    // <--------Whatsapp Integration-------->
    {
      path: "/cms/whatsapp-mapping",
      exact: true,
      application:'registration',
      action:'Manage Whatsapp Mapping',
      element: <DomainMapping />
    },

  ];

  return (
    <>
      <Routes>
        {/* <Suspense fallback={<Loading />}> */}
        {ROUTES.map((obj, index) => {
          let flag = true;
          flag = userPermission?.find((permission) => {
            if (
              (obj.application == permission.content_type || obj.application == permission.codename ||
                !obj.application) &&
              (obj.action == permission.name || !obj.action)
            ) {
              return true;
            }
          });
          if (flag || obj.application == "") {
            return (
              <Route
                key={index}
                path={obj.path}
                exact={obj.exact}
                element={obj.element}
              // render={(props) => (
              //   <obj.component
              //     {...props}
              //     user={user}
              //     permission={userPermission}
              //   />
              // )}
              />
            );
          } else {
            return (
              <Route
                key={index}
                path={obj.path}
                exact={obj.exact}
                element={<PermissionDenied />}
                // element={obj.element}
              />
            );
          }
        })}
        {/* </Suspense> */}
      </Routes>
    </>
  );
};
export default CMSRoutes;